export default __webpack_public_path__ + "static/media/mision.0726196e.jpg";